import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { ModalController, ToastController } from "@ionic/angular";

@Component({
  selector: "appeal-approve-doc-reject-case",
  templateUrl: "./appeal-approve-doc-case.component.html",
})
export class AppealApproveDocComponent implements OnInit {
  approveForm: FormGroup = new FormGroup({});
  pan: string;
  applicantName: string;

  constructor(
    private modalCtrl: ModalController,
    private toastController: ToastController
  ) {}

  ngOnInit(): void {
    this.approveForm = new FormGroup({
      approveReason: new FormControl(null, [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(3500),
      ]),
    });
  }

  async showErrorToast(errorMessage: string) {
    const toast = await this.toastController.create({
      message: errorMessage,
      icon: "information-circle",
      position: "top",
      duration: 2000,
    });
    toast.present();
  }

  async ngSubmit() {}
  handleKeyPress(event: KeyboardEvent): void {
    const textarea = event.target as HTMLTextAreaElement;
    const cursorPosition = textarea.selectionStart;
    if (cursorPosition === 0 && event.key === " ") {
      event.preventDefault();
    }
  }
  approve() {
    console.log("this.rejectForm", this.approveForm.value.approveReason);
    if (!this.approveForm.value.approveReason) {
      this.showErrorToast("Please Enter Approve Remark");
    }

    if (this.approveForm.valid) {
      return this.modalCtrl.dismiss(
        this.approveForm.value.approveReason,
        "approve"
      );
    }
  }

  cancel() {
    return this.modalCtrl.dismiss(null, "cancel");
  }
}
